import { ApiClient } from '@dozuki/web-js/utils';
import { QueryClient, useQuery } from '@tanstack/react-query';
import { getSiteInfo, getSiteInfoFromClient, SiteInfo } from '~/pages/api/sites';

const KEY = 'site-info';

export function useSiteInfo() {
   return useQuery({
      queryFn: () => getSiteInfoFromClient(),

      queryKey: [KEY],

      // 30 minutes
      staleTime: 1800000,

      // We always want this data available so that things like the header never have a loading state
      cacheTime: Infinity,
   });
}

export async function prefetchSiteInfo(apiClient: ApiClient, queryClient: QueryClient) {
   await queryClient.fetchQuery([KEY], () => getSiteInfo({ apiClient }));
}

export function setSiteInfo(queryClient: QueryClient, siteInfo: SiteInfo): void {
   queryClient.setQueryData([KEY], siteInfo);
}
